import type { Attachment } from '@tadpoles/common'

export function isHlsAttachment(attachment: Readonly<Attachment>): boolean {
    const mimeType = attachment.mimeType.toLowerCase()
    return mimeType === 'application/x-mpegurl' || mimeType === 'application/vnd.apple.mpegurl'
}
